import { RandomUtils } from '../utils/random-utils';

export enum ContractStatusEnum {
  DRAFT = 'DRAFT',
  VALIDATED = 'VALIDATED',
  EXPIRED = 'EXPIRED',
  SUSPENDED = 'SUSPENDED',
}

export class ContractStatusTranslation {
  static translate(status: ContractStatusEnum): string {
    switch (status) {
      case ContractStatusEnum.DRAFT:
        return 'Brouillon';
      case ContractStatusEnum.VALIDATED:
        return 'Actif';
      case ContractStatusEnum.EXPIRED:
        return 'Echu';
      case ContractStatusEnum.SUSPENDED:
        return 'Suspendu';
      default:
        return null;
    }
  }
}

export const contractStatusTranslation = (status: ContractStatusEnum) => {
  switch (status) {
    case ContractStatusEnum.DRAFT.toString():
      return 'Brouillon';
    case ContractStatusEnum.VALIDATED.toString():
      return 'Actif';
    case ContractStatusEnum.EXPIRED:
      return 'Echu';
    case ContractStatusEnum.SUSPENDED.toString():
      return 'Suspendu';
    default:
      return null;
  }
};

export const contractStatusTranslationObject = (status: ContractStatusEnum) => {
  return {
    _id: RandomUtils.generateId(),
    value: status,
    label: ContractStatusTranslation.translate(status),
  };
};
